var actionCreatorFactory = function actionCreatorFactory(type) {
  return function (_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
      payload = _ref.payload,
      error = _ref.error;
    return Object.assign({
      type: type
    }, payload && {
      payload: payload
    }, error && {
      error: error
    });
  };
};
var types = {
  FETCH_MARKDOWN: 'FETCH_MARKDOWN',
  FETCH_MARKDOWN_SUCCESS: 'FETCH_MARKDOWN_SUCCESS',
  FETCH_MARKDOWN_ERROR: 'FETCH_MARKDOWN_ERROR',
  FETCH_JSON: 'FETCH_JSON',
  FETCH_JSON_SUCCESS: 'FETCH_JSON_SUCCESS',
  FETCH_JSON_ERROR: 'FETCH_JSON_ERROR'
};
var creators = {
  fetchMarkdown: actionCreatorFactory(types.FETCH_MARKDOWN),
  fetchMarkdownSuccess: actionCreatorFactory(types.FETCH_MARKDOWN_SUCCESS),
  fetchMarkdownError: actionCreatorFactory(types.FETCH_MARKDOWN_ERROR),
  fetchJson: actionCreatorFactory(types.FETCH_JSON),
  fetchJsonSuccess: actionCreatorFactory(types.FETCH_JSON_SUCCESS),
  fetchJsonError: actionCreatorFactory(types.FETCH_JSON_ERROR)
};

export { creators, types };
//# sourceMappingURL=actions.js.map
